module.exports = __webpack_public_path__ + "static/12-6702da2642c92af7cb5d58152b87d80d.png";